module.exports = __webpack_public_path__ + "img/holy.164adbba.jpg";